/**
 * Whether the certificate form (L1 / L2 / L3 payment review) shows the
 * "Permit No" and "Copy To" boxes. The certificate now prints the Application
 * ID as the Permit No. and a fixed Copy to list, so both boxes are hidden.
 * Set to true to bring them back.
 */
export const SHOW_COPY_TO_AND_PERMIT_NO = false;

/**
 * Whether the certificate form shows the Permit No box. The reviewer types the
 * Permit No. there and the certificate prints it (blank when left empty).
 */
export const SHOW_PERMIT_NO = true;

/**
 * Whether reviewers get the pencil to change the certificate conditions on
 * the L1 / L2 / L3 certificate form. The conditions are set in Admin
 * (Certificate Conditions), so reviewers only see them.
 */
export const SHOW_CONDITIONS_EDIT = false;
